// Mirrors ScanRetentionRules.MinDays / MaxDays on the backend.
export const MAX_SCAN_RETENTION_DAYS = 36525;
export const MIN_SCAN_RETENTION_DAYS = 7;
